import { CheckboxProps as MUICheckboxProps } from "@material-tailwind/react";

export type CheckboxProps = Omit<MUICheckboxProps, "ref"> & {
  className?: string;
  labelClassName?: string;
  small?: boolean;
};

export default function Checkbox(props: CheckboxProps): JSX.Element {
  return (
    <label
      className={`flex items-center w-full cursor-pointer ${
        props.small ? "px-2 py-1" : "p-4"
      } formLabel`}
    >
      <input
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
        value={props.value}
        className={`appearance-none focus:outline-none  ${
          props.small ? "w-4 h-4 border-2 rounded-sm" : "rounded w-8 h-8 border-[3px]"
        }  border-ldir-brown-900 bg-ldir-brown-300 checked:bg-ldir-blue-900 checked:border-ldir-blue-900 relative focus:outline-offset-4`}
      />
      {props.checked &&
        (props.small ? (
          <span className={`pointer-events-none mr-1 -ml-3.5 z-10`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="10"
              viewBox="0 0 12 10"
              fill="none"
            >
              <title>valgt</title>
              <path
                d="M4.59998 9.2L11.65 2.15L10.25 0.75L4.59998 6.4L1.74998 3.55L0.349976 4.95L4.59998 9.2Z"
                fill="white"
              />
            </svg>
          </span>
        ) : (
          <span className={`pointer-events-none -ml-7 mr-1 z-10`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="20"
              viewBox="0 0 24 20"
              fill="none"
            >
              <title>valgt</title>
              <path d="m9.2 18.4 14.1 -14.1 -2.8 -2.8L9.2 12.8 3.5 7.1l-2.8 2.8z" fill="white" />
            </svg>
          </span>
        ))}
      <span
        className={` ${props.small ? "text-lg ml-2  " : "text-xl ml-4"} text-ldir-brown-900 flex-1`}
      >
        {props.label}
      </span>
    </label>
  );
}
